import { Entity } from '../entity';
import { JobType } from '../tenant/job.type';
import { Policy, PolicyNotification } from './policy';

export enum JobPolicyReminderType {
    NextAppointment = 'Next Appointment',
}

export enum JobPolicyNotificationType {
    JobCreated = 'Job Created',
    JobFirstDispatch = 'Job First Dispatch',
    JobStatusChange = 'Job Status Change',
    StageStatusChange = 'Stage Status Changed',
    ResourceEnroute = 'Resource Enroute',
    ResourceOnsite = 'Resource Onsite',
    ResourceCheckedOut = 'Resource Checked Out',
}

export type JobPolicyNotification = PolicyNotification<JobPolicyNotificationType>;

export interface JobPolicyNotifications {
    _id: string;
    enabled: boolean;
    created: JobPolicyNotification;
    firstDispatch: JobPolicyNotification;
    statusChanged: JobPolicyNotification;
    stageStatusChanged: JobPolicyNotification;
    resourceEnroute: JobPolicyNotification;
    resourceOnsite: JobPolicyNotification;
    resourceCheckedOut: JobPolicyNotification;
}


export interface JobPolicyReminder extends PolicyNotification<JobPolicyReminderType> {
    offset: number;
}

export interface JobPolicyReminders {
    _id: string;
    enableNextAppointment: boolean;
    nextAppointment: JobPolicyReminder[];
}

export interface JobPolicyDefaults {
    _id: string;
}

export interface JobPolicy extends Policy {
    emailNotifications: JobPolicyNotifications;
    smsNotifications: JobPolicyNotifications;
    reminders: JobPolicyReminders;
    defaults: JobPolicyDefaults;
    companies: Entity[];
    jobTypes: JobType[];
}

export const defaultJobPolicy: JobPolicy = {
    _id: null,
    isDefault: false,
    active: true,
    name: '',
    updatedBy: null,
    createdBy: null,
    reminders: {
        _id: null,
        enableNextAppointment: false,
        nextAppointment: [],
    },
    emailNotifications: {
        _id: null,
        enabled: false,
        created: null,
        firstDispatch: null,
        statusChanged: null,
        stageStatusChanged: null,
        resourceEnroute: null,
        resourceOnsite: null,
        resourceCheckedOut: null,
    },
    smsNotifications: {
        _id: null,
        enabled: false,
        created: null,
        firstDispatch: null,
        statusChanged: null,
        stageStatusChanged: null,
        resourceEnroute: null,
        resourceOnsite: null,
        resourceCheckedOut: null,
    },
    defaults: {
        _id: null,
    },
    companies: null,
    jobTypes: null,
}